/**
 * Éditeur de liste d'étiquettes (indices, mots-clés) du formulaire d'exercice.
 */

import React from 'react';
import { Box, Typography, Button, Chip, TextField } from '@mui/material';
import { Add } from '@mui/icons-material';

interface TagListEditorProps {
  title: string;
  placeholder: string;
  value: string;
  onValueChange: (value: string) => void;
  onAdd: () => void;
  items: string[];
  onRemove: (index: number) => void;
  color: 'primary' | 'secondary';
}

/** Champ de saisie + bouton Ajouter + Chips supprimables. */
export const TagListEditor: React.FC<TagListEditorProps> = ({
  title, placeholder, value, onValueChange, onAdd, items, onRemove, color,
}) => (
  <>
    <Typography variant="subtitle2" gutterBottom>
      {title}
    </Typography>
    <Box display="flex" gap={1} mb={1}>
      <TextField
        fullWidth
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            onAdd();
          }
        }}
      />
      <Button
        variant="outlined"
        startIcon={<Add />}
        onClick={onAdd}
      >
        Ajouter
      </Button>
    </Box>
    <Box display="flex" flexWrap="wrap" gap={1}>
      {items.map((item, index) => (
        <Chip
          key={index}
          label={item}
          onDelete={() => onRemove(index)}
          color={color}
          variant="outlined"
        />
      ))}
    </Box>
  </>
);
